import React, { useEffect } from "react";
import { NavLink, Redirect, Route, useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../Actions/Actions";
import { fetchOpportunityData } from "../../seller-apis/apidataField";
import api from "../../seller-apis/api";
import ProductOpportunities from "./ProductOpportunities";
import NewProductOpportunities from "./NewProductOpportunities.js";

function ProductOpportunitiesTabs() {
  const { path, url } = useRouteMatch();
  const dispatch = useDispatch();
  const {
    productOpportunityCount,
    recommendedProductOpportunityCount,
  } = useSelector(state => state.ActionReducer);

  useEffect(() => {
    const countFilterData = {
      pageNo: 1,
      size: 1,
      filters: {
        status: "pending"
      },
      sortFilter: { "createdAt": -1 },
    };

    api.Opportunity.getRecommendedProducts(fetchOpportunityData({...countFilterData,filters:{}})).then((res) => {
      Actions.updateRecommendedProductOpportunityCount(dispatch, res.totalRecords);
    }).catch((err) => {
      console.log(err);
      Actions.updateRecommendedProductOpportunityCount(dispatch, 0);
    });

    api.Opportunity.getBroadcastProduct(fetchOpportunityData(countFilterData)).then((res) => {
      Actions.updateProductOpportunityCount(dispatch, res.totalRecords);
    }).catch((err) => {
      console.log(err);
      Actions.updateProductOpportunityCount(dispatch, 0);
    });
  }, [dispatch]);

  return (
    <>
      <div className="container mb-4">
        <div className="new-tabs">
          <div className="tab-container" style={{ position: "relative" }}>
            <NavLink to={`${url}/opportunities-based-on-your-category`} className="tabs">
              <i className="bi bi-box-seam me-2"></i>
                Opportunities based on your category
              <div className="menu-count-border order-menu-count">
                {productOpportunityCount}
              </div>
            </NavLink>
          {recommendedProductOpportunityCount>0 &&  <NavLink to={`${url}/products-you-might-have`} className="tabs">
              <i className="bi bi-diagram-2-fill me-2"></i>
              Products you might have
              <div className="menu-count-border order-menu-count">
                {recommendedProductOpportunityCount}
              </div>
            </NavLink>}
          </div>
        </div>
      </div>

      <Route exact path={path}>
        <Redirect to={`${url}/opportunities-based-on-your-category`} />
      </Route>
      <Route exact path={`${path}/opportunities-based-on-your-category`} component={ProductOpportunities} />
      <Route exact path={`${path}/products-you-might-have`} component={NewProductOpportunities} />
    </>
  );
}

export default ProductOpportunitiesTabs;
